
import Grid from "@mui/material/Grid";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import styles from "./AddNotesDrawer.module.css";
import { ButtonBase, IconButton, Typography } from "@mui/material";
import { CloseModal } from "../../../iconRef/referralIcons";
import { useAppSelector } from "../../../app/store/hooks";
import { SelectedDateSelector, UserMealPlanDataSelector } from "../../../app/mealPlan/mealPlan.slice";
import AddNotesSelectMealType from "./addNotesSelectMealType/AddNotesSelectMealType";
import { Grid2 } from "@mui/material";
import { useContext, useState } from "react";
import { TextField } from "@mui/material";
import { userIdSelector } from "../../../app/main/mainSlice";
import Loader from "../../../pages/mealPlan/Loader";
import { NOTE_GENERATION_API } from "../../../app/constants/constants";
import axios from "axios";
import { ErrorManagementContext } from "../../../utils/errorManagement/ErrorManagementProvider";
import { capitalizeMealType, formatCustomDate, getMealTime } from "../utils";
import ImageUploadBox from "./imageUploadBox/ImageUploadBox";
import { cloudinaryuploadedNoteImage } from "../../../services/restApiServices/cloudinaryUpload.services";

const mealTypes = ["Morning", "Afternoon", "Evening", "Night"];

const AddNoteHeader = ({ setDrawer, date }: { setDrawer: React.Dispatch<React.SetStateAction<boolean>>, date: Date }) => {
    const formattedDate = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short' }).format(date);

    return <Grid className={styles.heading_container}>
        <Grid className={styles.heading_content}>
            <Typography className={styles.heading_text} variant="caption4LightOutfit">Add Note on {formattedDate}</Typography>
        </Grid>
        <IconButton onClick={() => setDrawer(false)}><CloseModal /></IconButton>
    </Grid>
}

const AddNotesDrawer = ({ drawer, setDrawer, refetchNotes }: { drawer: boolean, setDrawer: React.Dispatch<React.SetStateAction<boolean>>, refetchNotes: () => Promise<void> }) => {
    const selectedDate = useAppSelector(SelectedDateSelector);
    const [selectedMealType, setSelectedMealType] = useState("Morning");
    const [noteContent, setNoteContent] = useState("");
    const [image, setImage] = useState<string | null>(null);

    const [loading, setLoading] = useState(false);
    const userId = useAppSelector(userIdSelector);
    const { cookClubLog } = useContext(ErrorManagementContext);

    const handleAddNote = async () => {
        if (!noteContent.trim() && !image) {
            cookClubLog("Please add a note or upload an image before submitting.", "", {}, { ui: { type: "warning" }, browserConsole: true });
            return;
        }
        setLoading(true);
        try {
            const message: { note_text?: string; image_url?: string } = {};
            if (noteContent.trim()) message.note_text = noteContent.trim();
            if (image) {
                const uploadResponse = await cloudinaryuploadedNoteImage({ imageUrl: image });
                message.image_url = uploadResponse.secure_url;
            }

            const payload = {
                userId,
                message,
                meal_type: capitalizeMealType(selectedMealType),
                scheduled_note_date: getMealTime(selectedMealType, selectedDate),
                timezone: formatCustomDate(new Date()),
            };

            await axios.post(NOTE_GENERATION_API, payload);
            await refetchNotes();
            resetForm();
        } catch (error) {
            cookClubLog("Error occurred while adding the note. Please try again.", "", {}, { ui: { type: "error" }, browserConsole: true });
            console.error("AddNote Error:", error);
        } finally {
            setLoading(false);
        }
    };


    const resetForm = () => {
        setNoteContent("");
        setImage(null);
        setDrawer(false);
    };

    return (
        <SwipeableDrawer
            anchor='bottom'
            disableSwipeToOpen
            onClose={() => setDrawer(false)}
            onOpen={() => setDrawer(true)}
            open={drawer}
            swipeAreaWidth={56}
            sx={{
                '& .MuiPaper-root': {
                    borderTopLeftRadius: '24px',
                    borderTopRightRadius: '24px',
                    maxWidth: '960px',
                    margin: 'auto',
                },
            }}
        >
            <Grid2 className={styles.drawer}>
                <Grid2 className={styles.drawer_content}>
                    <hr className={styles.swipe_indicator} />
                    {/* <AddNoteHeader setDrawer={setDrawer} date={selectedDate} /> */}
                    <AddNotesSelectMealType selectedMealType={selectedMealType} setSelectedMealType={setSelectedMealType} />
                    <ImageUploadBox image={image} setImage={setImage} />

                    <Grid2 className={styles.notes_textfield_container}>
                        <TextField
                            className={styles.notes_textfield}
                            multiline
                            sx={{
                                width: '100%',
                                height: '100%',
                                '& .MuiInputBase-root': {
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'stretch',
                                },
                                '& .MuiInputBase-input': {
                                    height: '100%',
                                    '&::placeholder': {
                                        fontSize: '18px',
                                        fontStyle: 'italic',
                                    },
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                }
                            }}
                            placeholder="Add a note about your meal, e.g., 'Had an apple for breakfast'"
                            variant="outlined"
                            value={noteContent}
                            onChange={(e) => setNoteContent(e.target.value)}
                        />

                    </Grid2>

                </Grid2>
                <Grid2 className={styles.add_notes_button_container}>
                    <ButtonBase onClick={handleAddNote} className={styles.add_notes_button}>
                        <Typography variant="caption3LightOutfit">Add Note</Typography>
                    </ButtonBase>
                </Grid2>

            </Grid2>
            <Loader loading={loading} />

        </SwipeableDrawer>
    )
}

export default AddNotesDrawer